// Filename - components/landing/Testimonials.js

import React, { useState }from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";



export default function Testimonials (){

  
    return (
      <Container fluid className="p-5">
          <Row className="mx-3 mt-3 mb-3">
            <h3 className="display-4" style={{color:'#639fdd'}}>What Our Users Are Saying </h3>
         </Row>

         <Row className="mb-5">
            <Col className="col-md-1">
               <h1 className="display-1 text-right"> <span className="mb-0 pb-0" style={{fontFamily: 'Times New Roman', color:'#639fdd'}}> &ldquo;</span></h1>
            </Col>
            <Col className="col-md-11">
              <Carousel> 
                <Carousel.Item interval={1500}> 
                  <img 
                    className="d-block w-100"
                    src="images/site/CarouselBackground.png"
                    alt="Carousel Background"
                  /> 
                  <Carousel.Caption> 
                    <p className="text-white lead">The workshop was so fun and enlightening! It was great to see how simple changes (like using the "yes, and" framework) can do so much to boost creativity within teams. I'll be implementing learnings from the session right away.</p> 
                    <p className="small"> <strong> - Nick Ellingson,</strong> Startup Ambassador and Director of Products at WTIA</p> 
                  </Carousel.Caption> 
                </Carousel.Item> 

                <Carousel.Item interval={1500}> 
                  <img 
                    className="d-block w-100"
                    src="images/site/CarouselBackground.png"
                    alt="Carousel Background"
                  /> 
                  <Carousel.Caption> 
                    <p className="text-white">We take a selective approach to determining the expert educators and organizations with which we partner, to ensure we always have the highest quality content to promote personalized global learning. MindAntix, with its expertise in helping learners of all ages develop key 21st century skills, is a perfect fit as a Belouga content partner. The How to Be an Inventor course is designed to provide students with the space to explore and experiment with new ideas and acquire the requisite skills to succeed not just as contributors, but as leaders in the global economy, and this is something we wish for all students who access materials through Belouga.</p> 
                    <p ><strong> - Evin Schwartz,</strong> Founder and CEO of Belouga </p> 
                  </Carousel.Caption> 
                </Carousel.Item> 

                <Carousel.Item interval={1500}> 
                  <img 
                    className="d-block w-100"
                    src="images/site/CarouselBackground.png"
                    alt="Carousel Background"
                  /> 
                  <Carousel.Caption> 
                    <p className="text-white lead">I didn't want it to end; more time more fun!</p> 
                    <p><strong> - Engineering Manager</strong> at Amazon </p> 
                  </Carousel.Caption> 
                </Carousel.Item> 

                <Carousel.Item interval={1500}> 
                  <img 
                    className="d-block w-100"
                    src="images/site/CarouselBackground.png"
                    alt="Carousel Background"
                  /> 
                  <Carousel.Caption> 
                    <p className="text-white">The outcome of the How To Be An Inventor course is a soft prototype. Some of the student creations that I saw were very interesting and the process of ideation to product development exposed the students into the world of creative thinking and building as a lifelong skill as opposed to a compartmentalized activity in a classroom to be done and forgotten. My son, who was a part of the pilot workshop has pitched a dozen product ideas to me in the past 6 months since he completed the above workshop and most of them are quite sensible if I can say so myself. More importantly, he took one of these ideas, built a hard prototype, and then convinced a friend to purchase it!</p> 
                    <p><strong> - Aman Narula,</strong> Founder of Positive Ally </p> 
                  </Carousel.Caption> 
                </Carousel.Item> 

                <Carousel.Item interval={1500}> 
                  <img 
                    className="d-block w-100"
                    src="images/site/CarouselBackground.png"
                    alt="Carousel Background"
                  /> 
                  <Carousel.Caption> 
                    <p className="text-white lead">My teachers so appreciated the research-based professional development on Creativity Fundamentals.  They were instantly engaged in an interactive, hands-on learning experience, and they left with lots of activities and high leverage instructional strategies to use with their students.  I highly recommend this training for all teachers!</p> 
                    <p><strong> - Becky Ballbach,</strong> Director of Student Support Services at Everett SD </p> 
                  </Carousel.Caption> 
                </Carousel.Item> 

                <Carousel.Item interval={1500}> 
                  <img 
                    className="d-block w-100"
                    src="images/site/CarouselBackground.png"
                    alt="Carousel Background"
                  /> 
                  <Carousel.Caption> 
                    <p className="text-white lead">Hacking Creativity 101 is a fun and engaging way for teams to learn how they can become more creative and collaborative.</p> 
                    <p><strong> - Mark Kotzer,</strong> Corporate Innovation Evangelist </p> 
                  </Carousel.Caption> 
                </Carousel.Item> 


              </Carousel> 
            </Col>
          </Row>

         

      </Container>
    )

}
